module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_honda_01.be7117b9.jpg";